import { Medicine } from '../../interfaces/medicine';
import { Prescription } from '../../interfaces/prescription';
import { Prescriber } from '../../interfaces/users';
import { PrescriberConfiguration } from '../../shared/prescriber';
import { TrackerEventService } from '../../containers/prescription/trackerEventService';
import { logger } from '../../helpers/logger';

export const GENERIC_LAB_VIEW_EVENT = 'backoffice_campaign_solution_generic_view';
export const GENERIC_LAB_CLICK_EVENT = 'backoffice_campaign_solution_generic_click';

export interface GenericLabEventContext {
  prescription: Prescription | null;
  prescriber: Prescriber | null;
  prescriberConfiguration: PrescriberConfiguration | null;
  isMobile: boolean;
}

/**
 * Dispara o evento de laboratório de genéricos com o mesmo contrato em todos os
 * fluxos que incluem medicamento (adição manual, edição e aplicação de modelo).
 *
 * O evento é ignorado quando o medicamento não tem laboratórios disponíveis,
 * porque nesse caso não houve escolha de laboratório a registrar.
 *
 * @param eventName Nome do evento no Amplitude.
 * @param flow Fluxo de origem, usado para segmentar o evento.
 * @param medicine Medicamento já enriquecido com os campos de laboratório.
 * @param context Dados da prescrição, do prescritor e do dispositivo.
 */
export function trackGenericLabEvent(
  eventName: string,
  flow: string,
  medicine: Medicine | any,
  context: GenericLabEventContext
): void {
  const { prescription, prescriber, prescriberConfiguration, isMobile } = context;

  if (!prescription || !medicine.LaboratoriosDisponiveis?.length) return;

  const selectedLab = medicine.LaboratoriosDisponiveis.find(
    (lab: { id: number; nome: string }) => lab.id === medicine.idLaboratorioSelecionado
  );

  TrackerEventService.track(prescription.idPrescricao, eventName, {
    flow,
    id_prescricao: prescription.idPrescricao,
    codigo_validacao: prescription.CodigoValidacao,
    id_parceiro: prescriberConfiguration?.idParceiro ?? null,
    id_medico: prescriber?.idPrescritor ?? null,
    id_paciente: prescription.Paciente?.idPaciente ?? null,
    id_medicamento: medicine.IdMedicamento,
    id_medicamento_ean: medicine.ListaEANS?.[0] ?? null,
    ambiente: process.env.APP_ENV_NAME === 'production' ? 'prod' : 'hom',
    is_mobile: isMobile,
    laboratory: selectedLab?.nome ?? 'sem preferência',
    laboratory_highlight: !!selectedLab && selectedLab.id === medicine.idLaboratorioPatrocinado,
    principio_ativo: medicine.PrincipiosAtivos?.map((principle: { Nome: string }) => principle.Nome).join(', ') ?? '',
  }).catch((error) => {
    logger.error(`Erro ao enviar evento ${eventName} de laboratório de genéricos`, error);
  });
}
